import { Controller } from 'react-hook-form';
import Select from '../../select/select';
import DateInput from '../../date-input/date-input';
import InputText from '../../inputs/input-text';
import {
  LockAuditLogActionEnum,
  LockAuditLogResultEnum,
  LockAuditLogTitle,
} from '../types';
import { LogFormTypes } from './types';

import cn from './styles.module.css';

export default function LogForm({
  control,
  organizations,
  userId,
  role,
  wuthoutCustomer,
}: LogFormTypes) {
  return (
    <div className={cn.formWrapper}>
      <div className={cn.formGroup}>
        <Controller
          control={control}
          name="action"
          render={({ field: { value, name } }) => (
            <Select
              name={name}
              value={value}
              title="Action"
              placeholder="Select action"
              list={[
                {
                  name: LockAuditLogTitle.AUTH_CREDENTIAL_PHONE_SEND_SMS,
                  value: LockAuditLogActionEnum.AUTH_CREDENTIAL_PHONE_SEND_SMS,
                },
                {
                  name: LockAuditLogTitle.USER_AUTH_EMAIL,
                  value: LockAuditLogActionEnum.USER_AUTH_EMAIL,
                },
                {
                  name: LockAuditLogTitle.USER_AUTH_PHONE,
                  value: LockAuditLogActionEnum.USER_AUTH_PHONE,
                },
                {
                  name: LockAuditLogTitle.USER_AUTH_PIN,
                  value: LockAuditLogActionEnum.USER_AUTH_PIN,
                },
                {
                  name: LockAuditLogTitle.USER_CONVERT_TOKEN,
                  value: LockAuditLogActionEnum.USER_CONVERT_TOKEN,
                },
                {
                  name: LockAuditLogTitle.USER_GENERATE_CHECKSUM,
                  value: LockAuditLogActionEnum.USER_GENERATE_CHECKSUM,
                },
                {
                  name: LockAuditLogTitle.USER_REFRESH_TOKEN,
                  value: LockAuditLogActionEnum.USER_REFRESH_TOKEN,
                },
                {
                  name: LockAuditLogTitle.USER_SEND_EMAIL_CODE_SIGNATURE,
                  value: LockAuditLogActionEnum.USER_SEND_EMAIL_CODE_SIGNATURE,
                },
                {
                  name: LockAuditLogTitle.USER_SEND_PUSH_CODE_SIGNATURE,
                  value: LockAuditLogActionEnum.USER_SEND_PUSH_CODE_SIGNATURE,
                },
                {
                  name: LockAuditLogTitle.USER_SEND_RESET_PASSWORD,
                  value: LockAuditLogActionEnum.USER_SEND_RESET_PASSWORD,
                },
                {
                  name: LockAuditLogTitle.USER_SEND_SMS_CODE_SIGNATURE,
                  value: LockAuditLogActionEnum.USER_SEND_SMS_CODE_SIGNATURE,
                },
                {
                  name: LockAuditLogTitle.USER_SEND_TOTP_CODE_SIGNATURE,
                  value: LockAuditLogActionEnum.USER_SEND_TOTP_CODE_SIGNATURE,
                },
                {
                  name: LockAuditLogTitle.USER_SET_PIN,
                  value: LockAuditLogActionEnum.USER_SET_PIN,
                },
                {
                  name: LockAuditLogTitle.USER_SIGNATURE_VERIFY_CODE,
                  value: LockAuditLogActionEnum.USER_SIGNATURE_VERIFY_CODE,
                },
                {
                  name: LockAuditLogTitle.USER_VERIFY_CODE,
                  value: LockAuditLogActionEnum.USER_VERIFY_CODE,
                },
                {
                  name: LockAuditLogTitle.USER_VERIFY_PASSWORD,
                  value: LockAuditLogActionEnum.USER_VERIFY_PASSWORD,
                },
                {
                  name: LockAuditLogTitle.USER_VERIFY_RESET_CODE,
                  value: LockAuditLogActionEnum.USER_VERIFY_RESET_CODE,
                },
                {
                  name: LockAuditLogTitle.USER_VERIFY_SIGNATURE,
                  value: LockAuditLogActionEnum.USER_VERIFY_SIGNATURE,
                },
                {
                  name: LockAuditLogTitle.USER_VERIFY_TOTP,
                  value: LockAuditLogActionEnum.USER_VERIFY_TOTP,
                },
                {
                  name: LockAuditLogTitle.USER_ACTIVATE_TOTP,
                  value: LockAuditLogActionEnum.USER_ACTIVATE_TOTP,
                },
                {
                  name: LockAuditLogTitle.USER_SEND_VALIDATE_CODE_TOTP,
                  value: LockAuditLogActionEnum.USER_SEND_VALIDATE_CODE_TOTP,
                },
                {
                  name: LockAuditLogTitle.USER_GENERATE_TOTP,
                  value: LockAuditLogActionEnum.USER_GENERATE_TOTP,
                },
                {
                  name: LockAuditLogTitle.USER_DELETE_TOTP,
                  value: LockAuditLogActionEnum.USER_DELETE_TOTP,
                },
                {
                  name: LockAuditLogTitle.USER_FORBIDDEN,
                  value: LockAuditLogActionEnum.USER_FORBIDDEN,
                },
              ]}
              disabled
              fullWidth
            />
          )}
        />
      </div>
      <div className={cn.formGroup}>
        <Controller
          control={control}
          name="result"
          render={({ field: { value, name } }) => (
            <Select
              name={name}
              value={value}
              title="Result"
              placeholder="Select result"
              list={[
                {
                  name: 'Successful',
                  value: LockAuditLogResultEnum.SUCCESSFUL,
                },
                {
                  name: 'Failed',
                  value: LockAuditLogResultEnum.FAILED,
                },
              ]}
              disabled
              fullWidth
            />
          )}
        />
      </div>
      {userId && !wuthoutCustomer && (
        <div className={cn.formGroup}>
          <Controller
            control={control}
            defaultValue=""
            name="userId"
            render={({ field: { value, name } }) => (
              <Select
                name={name}
                placeholder="Select customer"
                value={value}
                title={role === 'EMPLOYEE' ? 'Employee' : 'Customer'}
                list={organizations || []}
                disabled
                fullWidth
              />
            )}
          />
        </div>
      )}
      {!userId && (
        <div className={cn.formGroup}>
          <Controller
            control={control}
            defaultValue=""
            name="userId"
            render={({ field: { name } }) => (
              <InputText
                name={name}
                placeholder=""
                value="-"
                title={role === 'EMPLOYEE' ? 'Employee' : 'Customer'}
                className={cn.logItemInput}
                disabled
              />
            )}
          />
        </div>
      )}
      <div className={cn.formGroup}>
        <Controller
          control={control}
          defaultValue=""
          name="ipSource"
          render={({ field: { name, value } }) => (
            <InputText
              name={name}
              placeholder=""
              value={value}
              title="IP"
              className={cn.logItemInput}
              disabled
            />
          )}
        />
      </div>
      <div className={cn.formGroup}>
        <Controller
          control={control}
          name="createdAt"
          defaultValue=""
          render={({ field: { value } }) => (
            <DateInput
              title="Expires At"
              value={value}
              placeholder="Select date"
              className={cn.securityDatePicker}
              disabled
              withoutCustomSelector
              fullWidth
            />
          )}
        />
      </div>
    </div>
  );
}
